import { render, staticRenderFns } from "./DragGhost.vue?vue&type=template&id=27ffbd65&scoped=true"
import script from "./DragGhost.vue?vue&type=script&setup=true&lang=js"
export * from "./DragGhost.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DragGhost.vue?vue&type=style&index=0&id=27ffbd65&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ffbd65",
  null
  
)

export default component.exports